import { FormattedDate } from 'react-intl'

import Text, { TextProps } from 'app/components/base/Text'

interface CreatedAtProps {
  date?: string | number | Date
  sx?: TextProps['sx']
}

const CreatedAt: RFC<CreatedAtProps> = ({ date, sx }) => {
  return (
    <Text typography="body2" sx={{ color: 'text.third', ...sx }}>
      <FormattedDate value={date} year="numeric" month="short" day="numeric" />
    </Text>
  )
}

export default CreatedAt
